import { render, staticRenderFns } from "./NotOptimized.vue?vue&type=template&id=45bc514e&scoped=true&"
import script from "./NotOptimized.vue?vue&type=script&lang=js&"
export * from "./NotOptimized.vue?vue&type=script&lang=js&"
import style0 from "./NotOptimized.vue?vue&type=style&index=0&id=45bc514e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bc514e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VRow})
